// src/components/Footer.js
import { FaGithub, FaLinkedin, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Contact", href: "#contact" },
];

const socials = [
  { icon: FaWhatsapp, href: "https://wa.me/918860131912", label: "WhatsApp" },
  { icon: FaGithub, href: "https://github.com/mohdsazidkhan", label: "GitHub" },
  { icon: FaLinkedin, href: "https://linkedin.com/in/mohdsazidkhan", label: "LinkedIn" },
  { icon: FaEnvelope, href: "mailto:support@mohdsazidkhan.com", label: "Email" },
];

export default function Footer() {
  return (
    <footer className="relative bg-white border-t border-gray-200 text-center pt-10 pb-6 px-4">
      <div className="flex flex-wrap justify-center gap-6 mb-5">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="text-sm font-medium text-gray-700 hover:text-indigo-600 transition"
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="flex justify-center gap-4 mb-6">
        {socials.map(({ icon: Icon, href, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-50 border border-gray-100 text-gray-700 shadow-sm hover:text-indigo-600 hover:shadow-md hover:-translate-y-0.5 transition"
          >
            <Icon size={14} />
          </a>
        ))}
      </div>

      <p className="text-sm md:text-base text-gray-800">
        &copy; {new Date().getFullYear()} Mohd Sazid Khan. All rights reserved.
      </p>
      <a
        href="#home"
        className="inline-block mt-2 text-xs md:text-sm font-medium text-indigo-600 hover:underline"
      >
        Back to top ↑
      </a>
    </footer>
  );
}
